module.exports = __webpack_public_path__ + "media/images/gateway/coinbase-152df9e394a977c12eaa15eaebfa3c00.jpg";